import { GridFilterModel } from "@mui/x-data-grid";
import {
  FetchPaginatedApiModel,
  WithData,
  WithRecordID,
} from "../../models/shared/CommonModels";
import { SortingModel } from "../../models/shared/SortingModel";
import { api_url } from "../../utils/ApiContext";
import { appendStringFilterToUri } from "../../utils/filtering";
import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
} from "../apiCommon";
import { BeneCollezioneModel } from "../../models/api/response/bene/BeneCollezioneModel";

const TAKE_LIMIT = 15;

const setQueryParameters = (
  filter: GridFilterModel | undefined,
  sort: SortingModel
) => {
  let uri = api_url.concat("/api/collezionebene?");

  filter?.items.forEach((item) => {
    uri = appendStringFilterToUri(item.field, "nome", item.value, uri);
    uri = appendStringFilterToUri(item.field, "descrizione", item.value, uri);
  });

  uri = uri.concat("&sort_field=", sort.field.toString());
  uri = uri.concat("&sort_direction=", sort.direction.toString());

  uri = uri.endsWith("?") ? uri.concat("skip=") : uri.concat("&skip=");

  return uri;
};

const getCollezione = (
  selectedId: number,
  page: number,
  sort: SortingModel,
  filter?: GridFilterModel
) => {
  let uri = setQueryParameters(filter, sort);

  let skip = 0;
  let take = TAKE_LIMIT;
  if (page > 0) skip = page * take;

  return getRequest<FetchPaginatedApiModel<BeneCollezioneModel[]>>(
    uri.concat(
      "&skip=",
      skip.toString(),
      "&take=",
      take.toString(),
      "&selectedId=",
      selectedId.toString()
    )
  );
};

const createCollezioneBene = (postdata: WithData) => {
  return postRequest(api_url.concat("/api/collezionebene"), postdata.data);
};

const updateCollezione = (putdata: WithRecordID) => {
  return putRequest(
    api_url.concat("/api/collezionebene/", putdata.recordID.toString()),
    putdata.data
  );
};

const deleteCollezione = (id: number) => {
  return deleteRequest(api_url.concat("/api/collezionebene/", id.toString()));
};

const getAllCollezioni = () => {
  return getRequest<BeneCollezioneModel[]>(api_url.concat("/api/collezionebene"));
};

export {
  getCollezione,
  createCollezioneBene,
  updateCollezione,
  deleteCollezione,
  getAllCollezioni,
};
